export default __webpack_public_path__ + "static/media/GiraffePage2.2af0c963.txt";